import React, { useState } from 'react';
import styles from './FAQSection.module.css';

const FAQS = [
  {
    id: 1,
    question: "Do I need to book a table in advance?",
    answer: "Walk-ins are always welcome at Berli — the door is always open. That said, we recommend booking ahead on weekends and match nights, as it tends to fill up fast. Reserve through our website or give us a call directly."
  },
  {
    id: 2,
    question: "Where do your ingredients come from?",
    answer: "Every beer begins with a question: what does this land grow, and what can we make with it? Our ingredients are sourced from local farmers in Pune and Maharashtra — a commitment, not a marketing line. Fresh, honest, and rooted right here."
  },
  {
    id: 3,
    question: "Are dogs allowed at Berli?",
    answer: "Absolutely — and we mean that wholeheartedly. Berli Brewing Co. was built partly because of a dog, and it will always be a place where dogs and the people who love them are not just tolerated, but celebrated. Bring them along."
  },
  {
    id: 4,
    question: "How many beers do you have, and do they change?",
    answer: "We proudly serve 12 craft beers — because everyone deserves something made for their palate, not one token option. Our tap list includes house favourites alongside rotating seasonal and small-batch releases, so there is always something worth trying."
  },
  {
    id: 5,
    question: "Can I host a private event at Berli?",
    answer: "Yes — Berli is a place built for good company. Whether it's a corporate dinner, a birthday, or a brewery takeover, we'd love to host you. Reach out via our Contact page and we'll sort out the details."
  },
  {
    id: 6,
    question: "What is the Berli Loyalty Program?",
    answer: "Our regulars are family, and family deserves to be celebrated. The Berli Loyalty Program is our way of saying thank you to the ones who keep coming back. Ask any of our team when you're next in — they'll walk you through it."
  },
];

const FAQItem = ({ item, isOpen, onToggle }) => (
  <div className={`${styles.item} ${isOpen ? styles.itemOpen : ''}`}>
    <button
      className={styles.question}
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-controls={`faq-answer-${item.id}`}
      id={`faq-question-${item.id}`}
    >
      <span className={styles.questionText}>{item.question}</span>
      <span className={styles.icon} aria-hidden="true">
        {isOpen ? '−' : '+'}
      </span>
    </button>

    <div
      id={`faq-answer-${item.id}`}
      role="region"
      aria-labelledby={`faq-question-${item.id}`}
      className={styles.answerWrapper}
      style={{ maxHeight: isOpen ? '300px' : '0' }}
    >
      <p className={styles.answer}>{item.answer}</p>
    </div>
  </div>
);

const FAQSection = () => {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId(prev => prev === id ? null : id);

  return (
    <section className={styles.section}>
      <div className={styles.container}>

        <h2 className={styles.heading}>FAQs</h2>

        <div className={styles.list} role="list">
          {FAQS.map(item => (
            <FAQItem
              key={item.id}
              item={item}
              isOpen={openId === item.id}
              onToggle={() => toggle(item.id)}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQSection;